import type { ApiErrorCode } from '@bonboca/shared-schemas';

export type ApiClientErrorCode =
  | ApiErrorCode
  | 'NOT_IMPLEMENTED'
  | 'INTERNAL_ERROR'
  | 'NETWORK_ERROR';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: ApiClientErrorCode | undefined,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class NotImplementedError extends ApiError {
  constructor(message: string) {
    super(501, 'NOT_IMPLEMENTED', message);
    this.name = 'NotImplementedError';
  }
}

export function isNotImplemented(error: unknown): error is NotImplementedError {
  return error instanceof NotImplementedError;
}
